import { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Package, ShoppingCart, Heart, Truck, Store, Activity } from 'lucide-react';

export function Business() {
  const [activeTab, setActiveTab] = useState(0);

  // const openChat = () => {
  //   const chatButton = document.querySelector('[data-chat-trigger]') as HTMLButtonElement;
  //   if (chatButton) {
  //     chatButton.click();
  //   }
  // };

  const businesses = [
    {
      id: 0,
      title: '跨境物流解决方案',
      icon: Package,
      color: 'from-orange-600 to-yellow-400',
      image: 'https://images.unsplash.com/photo-1761195696590-3490ea770aa1?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3Nzg4Nzd8MHwxfHNlYXJjaHwxfHxsb2dpc3RpY3MlMjB3YXJlaG91c2UlMjB0ZWNobm9sb2d5fGVufDF8fHx8MTc2NTQzOTczOHww&ixlib=rb-4.1.0&q=80&w=1080',
      services: [
        { icon: Truck, name: '国际快递/供应链/仓储/转运全链路服务' },
        { icon: Activity, name: '智能分拣系统、Dragon开放接口平台' },
        { icon: Package, name: '海外仓数字化管理解决方案' },
      ],
    },
    {
      id: 1,
      title: '电子商务生态',
      icon: ShoppingCart,
      color: 'from-red-600 to-orange-400',
      image: 'https://images.unsplash.com/photo-1762279388979-6a430989284c?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3Nzg4Nzd8MHwxfHNlYXJjaHwxfHxkYXRhJTIwdmlzdWFsaXphdGlvbiUyMG5ldHdvcmt8ZW58MXx8fHwxNzY1MzY5NTQ3fDA&ixlib=rb-4.1.0&q=80&w=1080',
      services: [
        { icon: Store, name: 'B2B/B2C/O2O全渠道电商平台' },
        { icon: ShoppingCart, name: '智慧商城+会员营销+智能客服系统' },
        { icon: Package, name: '跨境电商EShop解决方案' },
      ],
    },
    {
      id: 2,
      title: '智慧健康管理',
      icon: Heart,
      color: 'from-yellow-600 to-orange-400',
      image: 'https://images.unsplash.com/photo-1762341121807-c0a69eb8a92c?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3Nzg4Nzd8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjBvZmZpY2UlMjB0ZWNobm9sb2d5fGVufDF8fHx8MTc2NTQzNjcxMXww&ixlib=rb-4.1.0&q=80&w=1080',
      services: [
        { icon: Heart, name: '慢病/肥胖/高血压数字化管理方案' },
        { icon: Activity, name: '中医健康管理服务体系' },
        { icon: Activity, name: 'AI驱动的健康数据分析平台' },
      ],
    },
  ];

  return (
    <section id="business" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-16"
        >
          <div className="inline-block px-4 py-1 rounded-full bg-orange-50 text-orange-600 text-sm mb-4">
            核心业务
          </div>
          <h2 className="text-gray-900 mb-4">三大核心业务板块</h2>
          <p className="text-gray-600 max-w-2xl mx-auto">
            深耕行业多年，为客户提供专业的数字化解决方案
          </p>
        </motion.div>

        {/* Tabs */}
        <div className="flex flex-wrap justify-center gap-3 sm:gap-4 mb-12 px-4">
          {businesses.map((business, index) => (
            <button
              key={business.id}
              onClick={() => setActiveTab(index)}
              className={`flex items-center space-x-2 sm:space-x-3 px-4 sm:px-6 py-2 sm:py-3 rounded-full transition-all text-sm sm:text-base ${
                activeTab === index
                  ? `bg-gradient-to-r ${business.color} text-white shadow-lg`
                  : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
              }`}
            >
              <business.icon size={18} className="sm:w-5 sm:h-5" />
              <span className="hidden sm:inline">{business.title}</span>
              <span className="sm:hidden">{business.title.replace('解决方案', '').replace('生态', '').replace('管理', '')}</span>
            </button>
          ))}
        </div>

        {/* Content */}
        <AnimatePresence mode="wait">
          <motion.div
            key={activeTab}
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -20 }}
            transition={{ duration: 0.5 }}
            className="grid lg:grid-cols-2 gap-12 items-center"
          >
            {/* Image */}
            <div className="relative rounded-2xl overflow-hidden shadow-2xl order-2 lg:order-1">
              <img
                src={businesses[activeTab].image}
                alt={businesses[activeTab].title}
                className="w-full h-[400px] object-cover"
              />
              <div className={`absolute inset-0 bg-gradient-to-br ${businesses[activeTab].color} opacity-20`}></div>
            </div>

            {/* Services */}
            <div className="space-y-6 order-1 lg:order-2">
              <h3 className="text-gray-900">{businesses[activeTab].title}</h3>
              
              <div className="space-y-4">
                {businesses[activeTab].services.map((service, index) => (
                  <motion.div
                    key={index}
                    initial={{ opacity: 0, x: 20 }}
                    animate={{ opacity: 1, x: 0 }}
                    transition={{ duration: 0.5, delay: index * 0.1 }}
                    className="flex items-start space-x-4 p-4 rounded-xl bg-gray-50 hover:bg-gray-100 transition-colors"
                  >
                    <div className={`flex-shrink-0 w-10 h-10 rounded-lg bg-gradient-to-br ${businesses[activeTab].color} flex items-center justify-center`}>
                      <service.icon className="text-white" size={20} />
                    </div>
                    <div>
                      <p className="text-gray-800">{service.name}</p>
                    </div>
                  </motion.div>
                ))}
              </div>

              <a
                href="#contact"
                className={`inline-block px-6 py-3 rounded-full bg-gradient-to-r ${businesses[activeTab].color} text-white hover:shadow-lg transition-all`}
              >
                了解详情
              </a>
            </div>
          </motion.div>
        </AnimatePresence>
      </div>
    </section>
  );
}